import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Slide {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  to: string;
  tag: string;
}

const slides: Slide[] = [
  {
    id: 'slide-1',
    title: '泰坦尼克号',
    subtitle: '1997年经典重映 · 4K修复版震撼来袭，重温跨越阶级的世纪爱恋',
    image: 'https://readdy.ai/api/search-image?query=Grand%20vintage%20ocean%20liner%20sailing%20through%20deep%20navy%20blue%20sea%20at%20dusk%2C%20golden%20sunset%20light%20reflecting%20on%20water%2C%20romantic%20epic%20cinematic%20atmosphere%2C%20dramatic%20sky%20with%20soft%20clouds%2C%20highly%20detailed%20painterly%20style&width=1920&height=1080&seq=hero-slide-01&orientation=landscape',
    to: '/detail/titanic-1997',
    tag: '焦点电影',
  },
  {
    id: 'slide-2',
    title: '泰坦尼克号：血与钢',
    subtitle: '揭秘巨轮建造幕后，造船工人与命运的交织史诗',
    image: 'https://readdy.ai/api/search-image?query=Massive%20steel%20shipyard%20construction%20scene%20with%20workers%2C%20deep%20navy%20blue%20industrial%20tones%2C%20warm%20golden%20sparks%20and%20rim%20light%2C%20epic%20period%20drama%20atmosphere%2C%20cinematic%20wide%20shot&width=1920&height=1080&seq=hero-slide-02&orientation=landscape',
    to: '/detail/titanic-blood-and-steel',
    tag: '热门剧集',
  },
  {
    id: 'slide-3',
    title: '4K修复版即将重映',
    subtitle: '最新资讯 · 修复团队耗时两年打磨画面与音效',
    image: 'https://readdy.ai/api/search-image?query=Classic%20movie%20theater%20interior%20with%20glowing%20screen%20showing%20ocean%20liner%20silhouette%2C%20deep%20navy%20blue%20ambient%20lighting%2C%20golden%20spotlight%20beams%2C%20cinematic%20premiere%20atmosphere&width=1920&height=1080&seq=hero-slide-03&orientation=landscape',
    to: '/news/news-1',
    tag: '最新资讯',
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goPrev = () => setActive((prev) => (prev - 1 + slides.length) % slides.length);
  const goNext = () => setActive((prev) => (prev + 1) % slides.length);

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === active ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-950/30 to-primary-950/70"></div>
          <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4">
            <span className="inline-block px-4 py-1 rounded-full bg-accent-500/90 text-primary-950 text-xs font-semibold tracking-widest uppercase mb-5">
              {slide.tag}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-3xl">
              {slide.title}
            </h1>
            <p className="text-sm md:text-lg text-background-100/90 max-w-xl mb-8">{slide.subtitle}</p>
            <button
              onClick={() => navigate(slide.to)}
              className="px-7 py-3 rounded-full bg-secondary-500 hover:bg-secondary-600 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors"
            >
              查看详情
            </button>
          </div>
        </div>
      ))}

      <button
        onClick={goPrev}
        aria-label="上一张"
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={goNext}
        aria-label="下一张"
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => setActive(index)}
            aria-label={`切换到第${index + 1}张`}
            className={`h-1.5 rounded-full cursor-pointer transition-all ${
              index === active ? 'w-8 bg-accent-400' : 'w-2.5 bg-background-50/50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}